const more = {
  path: 'more',
  component: resolve => require(['../../../../components/pages/user/more'], resolve),
  redirect: 'more/detail',
  children: [{
    path: 'detail',
    component: resolve => require(['../../../../components/pages/user/more/detail'], resolve)
  }, {
    path: 'edit/:studentId',
    props: true,
    component: resolve => require(['../../../../components/pages/user/more/edit'], resolve)
  }]
}

export default more



// WEBPACK FOOTER //
// ./src/router/pages/user/more/index.js